module.exports = __webpack_public_path__ + "static/media/close-button.72a1e829.png";